import React from "react";
import { Stack } from "@mui/material";

import {
  HubHookFormDatePicker,
  HubHookFormInput,
  HubHookFormSelect,
} from "../../components";
import { FOUNDRIES } from "../../constants";

const FinancialPeriodForm = ({ defaultLocation, isEdit }) => (
  <Stack gap="15px" width="100%">
    <HubHookFormInput
      name="name"
      label="Period Name"
      placeholder="e.g. Q1 2026"
      required
    />
    <Stack direction="row" gap="10px">
      <HubHookFormSelect
        name="locationId"
        label="Location"
        options={FOUNDRIES}
        defaultValue={defaultLocation}
        disabled={isEdit}
        required
      />
      <HubHookFormDatePicker
        name="startDate"
        label="Start Date"
        placeholder="MM/DD/YYYY"
        required
      />
      <HubHookFormDatePicker
        name="endDate"
        label="End Date (optional)"
        placeholder="MM/DD/YYYY"
      />
    </Stack>
    <Stack direction="row" gap="10px">
      <HubHookFormInput
        name="historicalTreeCost"
        label="Historical Tree Cost"
        placeholder="0.00"
        defaultValue={0}
        isCurrency
      />
      <HubHookFormInput
        name="historicalMaterialCost"
        label="Historical Material Cost"
        placeholder="0.00"
        defaultValue={0}
        isCurrency
      />
      <HubHookFormInput
        name="historicalFactor"
        label="Historical Factor"
        placeholder="0.00"
        defaultValue={0}
        isCurrency
      />
    </Stack>
  </Stack>
);

export default FinancialPeriodForm;
